import { render } from "./EnglishTestQuestions.vue?vue&type=template&id=53e68b9a&scoped=true"
import script from "./EnglishTestQuestions.vue?vue&type=script&lang=js"
export * from "./EnglishTestQuestions.vue?vue&type=script&lang=js"

import "./EnglishTestQuestions.vue?vue&type=style&index=0&id=53e68b9a&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\Ned-ie\\ned_website-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e68b9a"]])

export default __exports__